import $ from 'jquery';
import Backbone from 'backbone';
import React, {lazy, Suspense} from 'react';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import DatadogUtil from 'performance/DatadogUtil';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

const API_ID_PREFIX = 'prt_';

const MainPage = lazy(() => import(/* webpackChunkName: "protocols" */ 'notebook/protocols/MainPage'));

class ProtocolsRouter extends Backbone.Router {
  static initClass() {
    this.prototype.routes = {
      'protocols/:apiIdentifier/:vanity': 'protocol',
      'protocols/:apiIdentifier/:vanity/sbs': 'stepbystep',
      'protocols/:apiIdentifier/:vanity/edit': 'edit',
    };
  }

  renderPage(route, params) {
    renderToDOM(
      <Suspense fallback={<CenteredHorizontalThrobber />}>
        <MainPage navLinks={window.bootstrap.navLinks} route={route} params={params} />
      </Suspense>,
      $('.protocols-mount')[0]
    );
  }

  protocol(apiIdentifier, vanity) {
    DatadogUtil.startRUMView('protocol');
    this.renderPage('protocol', {
      apiIdentifier: API_ID_PREFIX + apiIdentifier,
    });
  }

  stepbystep(apiIdentifier, vanity) {
    DatadogUtil.startRUMView('protocol_step_by_step');
    this.renderPage('stepbystep', {apiIdentifier: API_ID_PREFIX + apiIdentifier});
  }

  edit(apiIdentifier, vanity) {
    DatadogUtil.startRUMView('protocol_edit');
    this.renderPage('edit', {apiIdentifier: API_ID_PREFIX + apiIdentifier});
  }
}
ProtocolsRouter.initClass();

export default ProtocolsRouter;
